/* KobloText — shared text engine for BOTH editors (nightlight + ornament).
   Phase 1: the canonical glyph renderer, so text renders pixel-identically on
   both regardless of geometry. Each host calls drawLayer with its own basis:
     nightlight (square plate): {W:s, H:s, fontBasis:s, radiusBasis:s}   s=canvas.width
     ornament   (equirect):     {W:W, H:H, fontBasis:H, radiusBasis:W}
   Later phases move text STATE, controls, hit-testing + the mobile flow here too. */
(function () {
  var FAM = {
    "Playfair Display": "'Playfair Display',serif",
    "Montserrat": "'Montserrat',sans-serif",
    "Dancing Script": "'Dancing Script',cursive",
    "Oswald": "'Oswald',sans-serif",
    "Anton": "'Anton',sans-serif",
    "Archivo Black": "'Archivo Black',sans-serif"
  };

  function fontCss(name) { return FAM[name] || ("'" + name + "',sans-serif"); }
  function fontStr(t, fontSize) {
    return (t.italic ? "italic " : "") + (t.bold ? "700 " : "400 ") + fontSize + "px " + fontCss(t.font);
  }

  // Signed arc radius from a 10–100 curve amount. Curvature (1/radius) is what the
  // eye reads as "how curved", so we step CURVATURE linearly — radius-linear made
  // 10→20% barely move while 90→100% lurched. flip = bow down (frown) vs up (smile).
  // rb = radiusBasis (canvas width). Clamped to 10..100 (no flat/0, no negatives).
  function curveRadius(amount, flip, rb) {
    var a = Math.min(100, Math.max(10, Math.abs(amount == null ? 10 : amount))) / 100;
    var C0 = 1 / (rb * 3), C1 = 1 / (rb * 0.32);   // flattest → deepest curvature
    var mag = 1 / (C0 + a * (C1 - C0));
    return flip ? -mag : mag;
  }

  // Curved (arc) text — one char at a time around a circle. radius>0 bows up
  // (smile), radius<0 bows down (frown).
  function drawArc(ctx, text, apexX, apexY, radius, font, fill, stroke, strokeW) {
    if (!text) return;
    ctx.save();
    ctx.font = font; ctx.textBaseline = "middle"; ctx.textAlign = "center";
    ctx.fillStyle = fill; ctx.strokeStyle = stroke; ctx.lineWidth = strokeW; ctx.lineJoin = "round";
    var chars = text.split(""), widths = chars.map(function (c) { return ctx.measureText(c).width; });
    var total = widths.reduce(function (a, b) { return a + b; }, 0);
    var totalAngle = total / Math.abs(radius);
    ctx.translate(apexX, apexY + radius);
    var angle = -totalAngle / 2;
    for (var i = 0; i < chars.length; i++) {
      var chA = widths[i] / Math.abs(radius);
      angle += chA / 2;
      ctx.save();
      ctx.rotate(radius >= 0 ? angle : -angle);
      ctx.translate(0, -radius);
      if (strokeW > 0) ctx.strokeText(chars[i], 0, 0);
      ctx.fillText(chars[i], 0, 0);
      ctx.restore();
      angle += chA / 2;
    }
    ctx.restore();
  }

  // Canonical text-layer draw. t = {txt,font,size,color,bold,italic,underline,
  // outline,curved,curveAmount,align,x,y,boxW}. opts = {W,H,fontBasis,radiusBasis}.
  function drawLayer(ctx, t, opts) {
    if (!t || !t.txt) return;
    var W = opts.W, H = opts.H, fb = opts.fontBasis || H, rb = opts.radiusBasis || W;
    var lines = String(t.txt).split("\n");
    var fontSize = Math.round(t.size * fb / 100);
    var minStroke = Math.ceil(0.35 * fb / 108);
    var strokeW = Math.max(minStroke, fontSize * 0.035);
    var fill = t.color === "light" ? "#fff" : "#000";
    var outlineCol = t.color === "light" ? "#000" : "#fff";
    var outlineW = fontSize * 0.14;
    var drawW = t.outline ? outlineW : strokeW;
    var drawCol = t.outline ? outlineCol : fill;
    var font = fontStr(t, fontSize);
    var px = t.x * W, py = t.y * H;

    if (t.curved && lines.length === 1) {
      drawArc(ctx, lines[0], px, py, curveRadius(t.curveAmount, t.curveFlip, rb), font, fill, drawCol, drawW);
      return;
    }

    ctx.save();
    ctx.font = font; ctx.textAlign = t.align || "center"; ctx.textBaseline = "middle";
    ctx.fillStyle = fill; ctx.strokeStyle = drawCol; ctx.lineWidth = drawW; ctx.lineJoin = "round";
    var natW = 1;
    for (var i = 0; i < lines.length; i++) natW = Math.max(natW, ctx.measureText(lines[i]).width);
    var effBoxW = Math.max((t.boxW || 0) * W, natW);
    var anchorX = t.align === "left" ? px - effBoxW / 2 : t.align === "right" ? px + effBoxW / 2 : px;
    var lineH = fontSize * 1.2, totalH = lines.length * lineH;
    for (var l = 0; l < lines.length; l++) {
      var ty = py - totalH / 2 + l * lineH + lineH / 2;
      ctx.fillStyle = fill;
      ctx.strokeText(lines[l], anchorX, ty);
      ctx.fillText(lines[l], anchorX, ty);
      if (t.underline && lines[l].trim()) {
        var m = ctx.measureText(lines[l]), w = m.width;
        var ux = t.align === "center" ? anchorX - w / 2 : t.align === "right" ? anchorX - w : anchorX;
        var desc = (m.actualBoundingBoxDescent && isFinite(m.actualBoundingBoxDescent)) ? m.actualBoundingBoxDescent : fontSize * 0.37;
        var uy = ty + desc + fontSize * 0.14, uh = Math.max(1, fontSize * 0.055);
        if (t.outline) { ctx.fillStyle = drawCol; ctx.fillRect(ux - drawW * 0.4, uy - uh / 2 - drawW * 0.4, w + drawW * 0.8, uh + drawW * 0.8); }
        ctx.fillStyle = fill; ctx.fillRect(ux, uy - uh / 2, w, uh);
      }
    }
    ctx.restore();
  }

  // ── Auto-fit (shared) ───────────────────────────────────────────────────
  // Shrink a size (never grows) until the text fits maxFrac × refWidth. Pure —
  // returns the fitted size; the host assigns it. fontBasis scales the font,
  // refWidth is what the width is measured against (they differ on the ornament).
  function autoFitSize(ctx, opts) {
    var lines = String(opts.text || "").split("\n");
    var size = opts.size, min = opts.min || 5, maxW = opts.refWidth * opts.maxFrac;
    ctx.save();
    while (size > min) {
      var fs = Math.round(size * opts.fontBasis / 100);
      ctx.font = fontStr({ font: opts.font, bold: opts.bold, italic: opts.italic }, fs);
      var w = 0;
      for (var i = 0; i < lines.length; i++) w = Math.max(w, ctx.measureText(lines[i]).width);
      if (w <= maxW) break;
      size -= 1;
    }
    ctx.restore();
    return size;
  }

  // ── Formatting gating (shared) ──────────────────────────────────────────
  // Works on a plain layer {txt, curved, align} + a map of the layer's control
  // elements; mutates layer.curved/layer.align in place and updates the controls.
  // Host reads layer.curved/align back afterward. Rules (identical on both):
  // multi-line can't curve; curved disables Underline + locks alignment centre.
  function applyGating(layer, els) {
    var multiline = String(layer.txt || "").indexOf("\n") >= 0;
    if (els.curveRow) els.curveRow.style.display = multiline ? "none" : "";
    if (els.curveToggle) els.curveToggle.disabled = multiline;
    if (multiline && layer.curved) { layer.curved = false; if (els.curveStepper) els.curveStepper.style.display = "none"; if (els.curveToggle) els.curveToggle.checked = false; }
    if (els.underlineBtn) { els.underlineBtn.disabled = !!layer.curved; els.underlineBtn.classList.toggle("lw-font-btn--disabled", !!layer.curved); }
    if (layer.curved) layer.align = "center";
    if (els.alignBtns) ["left", "center", "right"].forEach(function (b) {
      var btn = els.alignBtns[b]; if (!btn) return;
      var off = layer.curved && b !== "center";
      btn.className = "lw-color-opt" + (b === layer.align ? " active-dark" : "") + (off ? " lw-align-disabled" : "");
      btn.disabled = off;
    });
    return layer;
  }

  // ── Selection UI (shared by both editors) ──────────────────────────────
  // box = {left,top,width,height} in the ctx's pixel units; opts.uiScale = px
  // per that same unit's CSS px (host passes uiScale matching its box units).
  function handlePoints(box, opts) {
    var k = opts.uiScale || 1, pad = 6 * k;
    var h = {
      tl: { x: box.left - pad, y: box.top - pad, cursor: "nwse-resize" },
      tr: { x: box.left + box.width + pad, y: box.top - pad, cursor: "nesw-resize" },
      bl: { x: box.left - pad, y: box.top + box.height + pad, cursor: "nesw-resize" },
      br: { x: box.left + box.width + pad, y: box.top + box.height + pad, cursor: "nwse-resize" }
    };
    if (opts.widthHandles) {
      h.rm = { x: box.left + box.width + pad, y: box.top + box.height / 2, cursor: "ew-resize", width: true };
      h.lm = { x: box.left - pad, y: box.top + box.height / 2, cursor: "ew-resize", width: true };
    }
    return h;
  }
  function deletePos(box, opts) { var k = opts.uiScale || 1; return { x: box.left + box.width + 18 * k, y: box.top - 18 * k }; }

  function drawSelection(ctx, box, opts) {
    opts = opts || {};
    var k = opts.uiScale || 1, SEL = "#1a8cff", off = 6 * k;
    ctx.save();
    ctx.lineWidth = 2.5 * k; ctx.strokeStyle = SEL;
    ctx.strokeRect(box.left - off, box.top - off, box.width + off * 2, box.height + off * 2);
    var hs = handlePoints(box, opts), hr = 7 * k;
    Object.keys(hs).forEach(function (key) {
      var h = hs[key];
      ctx.fillStyle = "#fff"; ctx.lineWidth = 2 * k; ctx.strokeStyle = SEL;
      if (h.width) {
        var bw = 5 * k, bh = 18 * k, rr = 2.5 * k, x = h.x - bw / 2, y = h.y - bh / 2;
        ctx.beginPath();
        if (ctx.roundRect) ctx.roundRect(x, y, bw, bh, rr); else ctx.rect(x, y, bw, bh);
        ctx.fill(); ctx.stroke();
      } else {
        ctx.beginPath(); ctx.arc(h.x, h.y, hr, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
      }
    });
    if (!opts.isMobile) {
      var del = deletePos(box, opts);
      ctx.beginPath(); ctx.arc(del.x, del.y, 10 * k, 0, Math.PI * 2); ctx.fillStyle = "#e53e3e"; ctx.fill();
      ctx.strokeStyle = "#fff"; ctx.lineWidth = 1.6 * k;
      ctx.beginPath();
      ctx.moveTo(del.x - 4 * k, del.y - 4 * k); ctx.lineTo(del.x + 4 * k, del.y + 4 * k);
      ctx.moveTo(del.x + 4 * k, del.y - 4 * k); ctx.lineTo(del.x - 4 * k, del.y + 4 * k);
      ctx.stroke();
      if (opts.hovering) {
        var label = opts.hoverLabel || "Delete";
        ctx.font = (11 * k) + "px sans-serif"; ctx.textAlign = "center"; ctx.textBaseline = "middle";
        var tw = ctx.measureText(label).width, pad2 = 6 * k, lx = del.x, ly = del.y - 22 * k;
        ctx.fillStyle = "rgba(30,30,30,0.92)"; ctx.fillRect(lx - tw / 2 - pad2, ly - 10 * k, tw + pad2 * 2, 20 * k);
        ctx.fillStyle = "#fff"; ctx.fillText(label, lx, ly);
      }
    }
    ctx.restore();
  }

  function hitTestHandle(box, px, py, opts) {
    opts = opts || {};
    var k = opts.uiScale || 1, hs = handlePoints(box, opts);
    var r = (opts.isMobile ? 22 : 14) * k;
    // width handles first — on short boxes the corners sit within the same radius.
    var order = opts.widthHandles ? ["rm", "lm", "tl", "tr", "bl", "br"] : ["tl", "tr", "bl", "br"];
    for (var i = 0; i < order.length; i++) {
      var h = hs[order[i]];
      if (h && Math.hypot(px - h.x, py - h.y) < r) return { corner: order[i], cursor: h.cursor, width: !!h.width };
    }
    return null;
  }
  function hitTestDelete(box, px, py, opts) {
    opts = opts || {};
    if (opts.isMobile) return false;
    var del = deletePos(box, opts);
    return Math.hypot(px - del.x, py - del.y) < 13 * (opts.uiScale || 1);
  }

  // LINE_H — line-height factor the renderer uses (hosts reuse it for box height).
  window.KobloText = {
    fontCss: fontCss, drawArc: drawArc, drawLayer: drawLayer, curveRadius: curveRadius, LINE_H: 1.2,
    autoFitSize: autoFitSize, applyGating: applyGating,
    handlePoints: handlePoints, deletePos: deletePos, drawSelection: drawSelection,
    hitTestHandle: hitTestHandle, hitTestDelete: hitTestDelete
  };
})();
